import { cashFlowRules } from '../cashFlowRule'
import { describeTable } from './describeTable'

describeTable(cashFlowRules, {
  description: `A recurring cash item the CFO maintains: rent, leasing, insurance, SaaS, net salaries, withholding and social charges. Each rule is materialised into cash_events occurrences (source 'rule') from today to the end of next calendar year; the rule is the definition, the events are the forecast. Re-saving a rule rewrites its occurrences except the ones someone edited (cash_events.overridden_at).`,
  columns: {
    category: 'Free-text bucket copied onto each occurrence.',
    direction: 'in or out.',
    amountNet:
      'Amount before VAT. The occurrence amount is amount_net × (1 + vat_rate).',
    vatRate: 'Decimal VAT rate: 0, 0.14 or 0.255.',
    certainty:
      'expected (default, known recurring cost) or forecast (planned, not yet contracted).',
    interval: "monthly, quarterly or yearly, anchored on start_date's month.",
    dayRule:
      'Day of the month the money moves, 1–31; 31 means the last day of the month.',
    startDate: 'First period. Nothing before today is generated.',
    endDate: 'Last day an occurrence may fall on. Null = open-ended.',
    supplierMatch:
      "Text matched case-insensitively inside a Fennoa purchase invoice's supplier name or a sales invoice's customer name. A matching invoice whose gross is within ±5 % of an occurrence and whose due date is within 7 days of it supersedes that one occurrence (closest amount first, then closest day); cash_events.superseded_by then names the invoice.",
    intercompanyCounterpartyCompanyId:
      "The other group company when the rule is an internal charge (management fee, software licence). The rule then writes two legs per date: its own occurrence in company_id, and a mirror with the direction reversed in this company (externalRef ending :mirror). Both legs carry the counterparty, so the group view drops them, and each company's own invoice to or from the other supersedes its own leg.",
    notes: 'Free text.',
  },
})
